import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    height: "48px",
    backgroundColor: "#ffffff",
    borderRadius: "5px",

    "& fieldset": {
      borderColor: "#d1d5db",
    },

    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },

    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: 1.5,
    },

    "&.Mui-error fieldset": {
      borderColor: theme.palette.error.main,
    },
  },

  "& .MuiOutlinedInput-input": {
    padding: "12px 14px",
    fontSize: "0.95rem",
    color: "#111827",
  },

  "& .MuiInputLabel-root": {
    fontSize: "0.85rem",
    color: "#6b7280",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.primary.main,
  },

  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    fontSize: "0.75rem",
  },
}));

const Textfield = React.forwardRef((props, ref) => {
  const {
    id,
    name,
    label,
    placeholder,
    type = "text",
    variant = "outlined",
    value,
    onChange,
    onBlur,
    error = false,
    helperText,
    disabled = false,
    required = false,
    size = "medium",
    autoComplete = "off",
    ...rest
  } = props;

  return (
    <StyledTextField
      ref={ref}
      id={id}
      name={name}
      type={type}
      variant={variant}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      size={size}
      autoComplete={autoComplete}
      fullWidth
      {...rest}
    />
  );
});

Textfield.displayName = "Textfield";

export default Textfield;
